import { Injectable } from '@angular/core';
import { Bewijsstukken, UploadResponse } from '@app/core/interfaces/bewijsstukken';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromClaims from '../actions/claims.actions';
import * as fromDocuments from '../actions/documents.actions';
import { DocumentsService } from './documents.service';

@Injectable()
export class DocumentsEffects {

     loadDocuments$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromDocuments.LOAD),
        switchMap((action: fromDocuments.Load) =>
            this.documentsService.getDocuments$(action.payload.dossier_volgnummer).pipe(
                map((resultaat) => resultaat.data),
                map((bewijsstukken: Bewijsstukken) => new fromDocuments.LoadSuccess({
                    bewijsstukken: bewijsstukken,
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                })),
                catchError((error) => of(new fromDocuments.LoadError(error))),
            ),
        ),
    ));

     submitDocuments$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromDocuments.SUBMIT),
        switchMap((action: fromDocuments.Submit) =>
            this.documentsService.submitDocuments$(action.payload.dossier_volgnummer, action.payload.upload_enveloppe_volgnummer).pipe(
                switchMap((response) => {
                    return [
                        new fromDocuments.SubmitSuccess({
                            data: response.data,
                            messages: response.messages,
                            dossier_volgnummer: action.payload.dossier_volgnummer,
                        }),
                        new fromClaims.UpdateDocumentActions({
                            dossier_volgnummer: action.payload.dossier_volgnummer,
                        }),
                    ];
                }),
                catchError((error) => of(new fromDocuments.SubmitError({
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                    message: error,
                }))),
            ),
        ),
    ));

     uploadDocuments$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromDocuments.UPLOAD),
        switchMap((action: fromDocuments.Upload) =>
            this.documentsService.uploadBewijsstuk$(action.payload.dossier_volgnummer, action.payload.upload).pipe(
                map((resultaat) => resultaat.data),
                map((response: UploadResponse) => new fromDocuments.UploadSuccess({
                    resultaat: response,
                    dossier_volgnummer: action.payload.dossier_volgnummer,
                    bewijsstuk_volgnummer: action.payload.bewijsstuk_volgnummer,
                })),
                catchError((error) => of(new fromDocuments.UploadError(error))),
            ),
        ),
    ));

     removeUploadDocuments$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromDocuments.REMOVE_UPLOAD),
        switchMap((action: fromDocuments.RemoveUpload) =>
            this.documentsService.removeUploadBewijsstuk$(
                action.payload.dossier_volgnummer,
                action.payload.upload_enveloppe_volgnummer,
                action.payload.upload_enveloppe_item_volgnummer).pipe(
                map( () => new fromDocuments.RemoveUploadSuccess(action.payload)),
                catchError((error) => of(new fromDocuments.UploadError(error))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions,
        private documentsService: DocumentsService,
    ) {}
}
